module.exports = __webpack_public_path__ + "static/media/icone-correto.6f02ff0f.svg";